module.exports = __webpack_public_path__ + "static/img/vigo.049e094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/vigo.png
// module id = OnDf
// module chunks = 0